import Icon from "~/components/ui/Icon"
import { HTMLWidget } from "~/types/widgets"

/**
 * @titleBy label
 */
interface Item {
    label: string
    url: string
}

/**
 * @titleBy title
 */
export interface Props {
    /**
     * @title Título
     */
    title: string
    /**
     * @title Itens
     * @description Lista de itens que será renderizado com prioridade (caso queira que o conteúdo personalizado seja renderizado, remova os itens dessa opção).
     */
    items?: Item[]
    /**
     * @title Conteúdo
     * @description Conteúdo personalizado
     */
    content?: HTMLWidget

    /**
     * @ignore
     */
    isMobile?: boolean
}

export default function Institutional({ title, items, content, isMobile }: Props) {
    if (isMobile) {
        return (
            <div className='w-full'>
                <div className='collapse rounded-none text-sm relative'>
                    <input type='checkbox' id={`input-${title}`} className='fixed hidden peer' />
                    <label
                        htmlFor={`input-${title}`}
                        className='group collapse-title font-bold text-salmon-light p-0 min-h-0 h-12 w-full flex justify-between items-center text-base'
                    >
                        <span>{title}</span>
                        <Icon
                            id='ChevronRight'
                            size={24}
                            strokeWidth={2}
                            className='peer-checked:group-[]:rotate-90 absolute right-3 top-1/2 -translate-y-1/2 transition-transform'
                        />
                    </label>
                    <div className='collapse-content !p-0'>
                        <div className='pt-2 pb-4 px-0'>
                            {items && items.length > 0
                                ? (
                                    <ul className='space-y-3'>
                                        {items.map(({ label, url }) => (
                                            <li key={url}>
                                                <a
                                                    className='flex w-full items-center font-bold'
                                                    href={url}
                                                >
                                                    <span>{label}</span>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                )
                                : content
                                ? <div dangerouslySetInnerHTML={{ __html: content }} />
                                : <></>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='space-y-3'>
            <p className='text-salmon-light font-bold'>{title}</p>
            {
                <ul className='flex flex-col text-sm font-semibold text-white gap-y-2'>
                    {items && items.length
                        ? (
                            items.map(({ label, url }) => (
                                <li key={url}>
                                    <a href={url}>{label}</a>
                                </li>
                            ))
                        )
                        : content
                        ? <div dangerouslySetInnerHTML={{ __html: content }} />
                        : <></>}
                </ul>
            }
        </div>
    )
}
